import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueApexCharts from 'vue3-apexcharts'
import can from './utils/can'
import { useAuthStore } from '@/stores/useAuthStore' // gunakan store yang benar

const app = createApp(App)
const pinia = createPinia()

// Pasang plugin/pinia/router dulu
app.use(pinia)
app.use(router)
app.use(can)
app.use(VueApexCharts)
app.use(VueReCaptcha, {
  siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true,
    explicitRender: false,
  }
})

// Buat store setelah pinia terpasang
const auth = useAuthStore()

// bootstrap: inisialisasi auth sebelum mount supaya router guard punya state
async function bootstrap() {
  try {
    console.log('[bootstrap] initSession start')
    await auth.initSession()
    console.log('[bootstrap] initSession done', { tokenExists: !!auth.token, userPresent: !!auth.user })
  } catch (e) {
    console.warn('[bootstrap] initSession error', e)
  } finally {
    await router.isReady()
    app.mount('#app')
    console.log('[bootstrap] app mounted')
  }
}

bootstrap()